import React from 'react';
import './Policy.css'

const Policy = () => {
    return (
        <div className="policy-section">
            <div className="container">
                <div className="policy-content">
                    <div className="policy-link">
                        <a className="devider" href="https://elitepartyz.com/privacy-policy/">Privacy Policy</a>
                        <a href="https://elitepartyz.com/terms-and-conditions">Terms & Conditions</a>
                    </div>
                    <div className="copyright">
                        <p>Copyright ©2022 Elite Partyz</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Policy
